import * as React from "react";
import "./screen.scss";

interface ScreenProps {
  withNavigation?: boolean;
  withBottomPadding?: boolean;
  withSubmitButton?: boolean;
  className?: string;
}

export const Screen: React.FC<ScreenProps> = ({ className, children }) => {
  return <div className={`c-screen ${className}`}>{children}</div>;
};
